import { Field, ID, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { AiUsage } from '../args/AiUsage'
import type { AiUsageRecord } from './AiUsageRecord'

@InputType()
export class RecordAiUsageArgs extends ActionArgs {
  /** Generic owner of this usage (a `User._id` or `Tenant._id`, per `resolveBillingOwnerId`). */
  @Field(() => ID)
  ownerId: string

  /** Caller-supplied feature tag (e.g. `quickscore.processScan`). */
  @Field(() => String)
  feature: string

  /** Token usage + resolved model from the underlying AI call (see `AnalyzeImage`/`AnalyzeImages`). */
  @Field(() => GraphQLJSON)
  usage: AiUsage

  /** Deterministic idempotency key for a caller that may retry the same billable unit of work (e.g. `${batchId}:${chunkIndex}`). */
  @Field(() => String, { nullable: true })
  chargeKey?: string

  /** Caller-supplied human-readable description of the charge, persisted onto `AiUsageRecord.remarks`. */
  @Field(() => String, { nullable: true })
  remarks?: string
}

export type RecordAiUsageResult = {
  /** Credits charged for this call, in the owner's account currency. */
  credits: number
  record: AiUsageRecord
}

/**
 * Prices a single metered AI call and persists one `AiUsageRecord`. Module-internal to
 * `ai-node` — injected by class (composed by `RecordAndDebitAiUsage`), never barrel-exported
 * and never bound to an `IocKey` symbol (`backend-style-guide.md` — "Never export actions/validators").
 */
export interface IRecordAiUsage {
  execute(args: RecordAiUsageArgs): Promise<RecordAiUsageResult>
}
